import { render } from "./NoResult.vue?vue&type=template&id=cd0d151c&scoped=true"
import script from "./NoResult.vue?vue&type=script&lang=js"
export * from "./NoResult.vue?vue&type=script&lang=js"

import "./NoResult.vue?vue&type=style&index=0&id=cd0d151c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0d151c"]])

export default __exports__